import React from "react";

import Tooltip from "antd/es/tooltip";
import { useIntl } from "react-intl";

import { EntitiesSupportedByEmailFeature } from "@mapmycustomers/shared/types/entity";

import EmailView from "@app/component/email/EmailLink";
import { RegistryProps } from "@app/component/FieldGrid/utils/ComponentRegistry";

import styles from "./EmailField.module.scss";

const EmailField = ({ entity, field }: RegistryProps) => {
  const intl = useIntl();

  const value = field.getValueFor(entity) as string;
  return (
    <Tooltip
      placement="top"
      title={intl.formatMessage({
        id: "fieldGrid.field.email.tooltip",
        defaultMessage: "Send email",
        description: "Send email tooltip",
      })}
    >
      <div className={styles.container}>
        <EmailView
          className={styles.email}
          email={value}
          entity={entity as EntitiesSupportedByEmailFeature}
          showIcon={false}
        />
      </div>
    </Tooltip>
  );
};

export default EmailField;
